import {
  CustomButton,
  CustomImage,
  successDialog,
  CustomTable,
  Text,
  CustomModal,
  useText,
} from '@src/components';
import React, { useCallback, useState, useEffect } from 'react';
import '@src/styles/companyInformation/deliveryAdresses/deliveryAdressesList.scss';
import { Button, Dropdown } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import iconEllipsis from '@src/assets/icons/icon-ellipsis.svg';
import iconPlusBlack from '@src/assets/icons/icon-plus-black.svg';
import iconFilterNew from '@src/assets/icons/icon-filter-new.svg';
import modalClose from '@src/assets/icons/icon-close.svg';
import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons';
import DeliveryAddressAddModal from './DeliveryAddressAddModal';
import {
  resetResponse,
  addressDelete,
  addressGetPagedListByUserQuery,
} from '@src/store/slice/addressSlice';
import { handleAuthStatus } from '@src/utils/utils';
import UpdateMenu from './UpdateMenu';
import FilterMenu from './FilterMenu';
function getExpandIcon() {
  return ({ expanded, onExpand, record }) =>
    expanded ? (
      <UpCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    ) : (
      <DownCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    );
}

function getExpandedRowRender(handleDelete, handleEdit) {
  return (record) => (
    <div className="custom-expanded-row" key={record.id}>
      <div className="colum-title">
        <span><Text t="neighborhoodUpperCase" /></span> <span>{record.neighborhoodId}</span>
      </div>
      <div className="colum-title">
        <span>TESLİM ALACAK KİŞİ:</span>{' '}
        <span>
          {record.receiverName} {record?.receiverSurName}
        </span>
      </div>
      <div className="colum-title">
        <span>
          <Text t="openAddress2" />
        </span>{' '}
        <span>{record.addressName}</span>
      </div>

      <div className="mobile-action-btn">
        <CustomButton
          id="companyInformation-deliveryAddress-deliveryAddressedList-delete-btn"
          buttonAuthName="DeliveryAddressesDelete"
          className="delete-btn"
          onClick={() => handleDelete(record.id)}
        >
          <Text t="delete" />
        </CustomButton>
        <CustomButton
          id="companyInformation-deliveryAddress-deliveryAddressedList-edit-btn"
          buttonAuthName="DeliveryAddressesEdit"
          className="edit-btn"
          onClick={() => handleEdit(record)}
        >
          <Text t="edit" />
        </CustomButton>
      </div>
    </div>
  );
}

const DeliveryAdressesList = () => {
  const [expandedRows, setExpandedRows] = useState([]);
  const [isModalDeliveryAddressAdd, setIsModalDeliveryAddressAdd] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [filterDeliveryOwners, setFilterDeliveryOwners] = useState([]);
  const [filterCitys, setFilterCitys] = useState([]);
  const [filterCountys, setFilterCountys] = useState([]);
  const [filterNeighborhoods, setFilterNeighborhoods] = useState([]);
  const [checkedFilterDeliveryOwners, setCheckedFilterDeliveryOwners] = useState([]);
  const [checkedFilterCitys, setCheckedFilterCitys] = useState([]);
  const [checkedFilterCountys, setCheckedFilterCountys] = useState([]);
  const [checkedFilterNeighborhoods, setCheckedFilterNeighborhoods] = useState([]);
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
  const [selectedRowDelete, setSelectedRowDelete] = useState(false);
  const [panels, setPanels] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [filteredText, setFilteredText] = useState('');
  const { userAuthorizationStatus } = useSelector((state) => state?.user);
  const { selectedCustomer } = useSelector((state) => state?.customer);

  const {
    response,
    addressPagedList,
    filterCityList,
    filterCountyList,
    filterDeliveryOwnerList,
    filterNeighborhoodList,
  } = useSelector((state) => state?.address);

  const dispatch = useDispatch();

  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [addressPagedList]);

  useEffect(() => {
    loadAdressList();
  }, []);

  useEffect(() => {
    if (selectedRowDelete) {
      if (Number(selectedRecord?.cardCount) > 0 || Number(selectedRecord?.carCount) > 0) {
        setIsVisibleDeleteModal(true);
      } else {
        handleDelete(selectedRecord);
      }
    }
  }, [selectedRowDelete]);

  useEffect(() => {
    setPanels([
      {
        list: checkedFilterDeliveryOwners,
        setList: setCheckedFilterDeliveryOwners,
        text: <Text t="deliveryOwner" />,
        initialList: filterDeliveryOwners,
        key: 'filterDeliveryOwners',
      },
      {
        list: checkedFilterCitys,
        setList: setCheckedFilterCitys,
        text: <Text t="province" />,
        initialList: filterCitys,
        key: 'filterCitys',
      },
      {
        list: checkedFilterCountys,
        setList: setCheckedFilterCountys,
        text: <Text t="district" />,
        initialList: filterCountys,
        key: 'filterCountys',
      },
      {
        list: checkedFilterNeighborhoods,
        setList: setCheckedFilterNeighborhoods,
        text: <Text t="neighborhood" />,
        initialList: filterNeighborhoods,
        key: 'filterNeighborhoods',
      },
    ]);
  }, [
    checkedFilterDeliveryOwners,
    checkedFilterCitys,
    checkedFilterCountys,
    checkedFilterNeighborhoods,
    filterDeliveryOwners,
    filterCitys,
    filterCountys,
    filterNeighborhoods,
  ]);

  useEffect(() => {
    try {
      if (filterDeliveryOwnerList) {
        setFilterDeliveryOwners(
          Object.entries(filterDeliveryOwnerList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [filterDeliveryOwnerList]);

  useEffect(() => {
    try {
      if (filterCityList) {
        setFilterCitys(
          Object.entries(filterCityList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [filterCityList]);

  useEffect(() => {
    try {
      if (filterCountyList) {
        setFilterCountys(
          Object.entries(filterCountyList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [filterCountyList]);

  useEffect(() => {
    try {
      if (filterNeighborhoodList) {
        setFilterNeighborhoods(
          Object.entries(filterNeighborhoodList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [filterNeighborhoodList]);

  useEffect(() => {
    if (!response) return;
    if (Object.keys(response)?.length) {
      if (response?.isSuccess) {
        successDialog({
          title: <Text t="success" />,
          message: yourTransactionHasBeenSuccessfullyCompleted,
          onOk: () => {
            loadAdressList();
            setIsModalDeliveryAddressAdd(false);
          },
        });
      }
      return dispatch(resetResponse());
    }
  }, [response]);

  const clickFilter = async () => {
    try {
      const filter = {
        deliveryOwnerIds: checkedFilterDeliveryOwners?.map((it) => parseInt(it, 10)),
        cityIds: checkedFilterCitys?.map((it) => parseInt(it, 10)),
        countyIds: checkedFilterCountys?.map((it) => parseInt(it, 10)),
        neighborhoodIds: checkedFilterNeighborhoods?.map((it) => parseInt(it, 10)),
        deliveryAddressName: filteredText,
      };
      await dispatch(loadAdressList({ filter }));
    } catch (error) {
      console.error(error);
    }
  };

  const clearFilter = () => {
    try {
      setCheckedFilterDeliveryOwners([]);
      setCheckedFilterCitys([]);
      setCheckedFilterCountys([]);
      setCheckedFilterNeighborhoods([]);
      setFilteredText('');
      handleAdressTableChange();
    } catch (e) { }
  };

  const loadAdressList = useCallback(
    async (filter) => {
      await dispatch(
        addressGetPagedListByUserQuery({
          body: { ...filter },
          pageNumber: 1,
          pageSize: 10,
          customerId: selectedCustomer?.customerId,
        }),
      );
    },
    [dispatch],
  );

  const handleAdressTableChange = useCallback(
    (pageNumber, pageSize) => {
      dispatch(
        addressGetPagedListByUserQuery({
          pageNumber,
          pageSize: 10,
          customerId: selectedCustomer?.customerId,
        }),
      );
    },
    [dispatch],
  );

  const handleAdd = useCallback((record) => {
    setIsModalDeliveryAddressAdd(true);
    setSelectedRow(false);
  }, []);

  const handleEdit = useCallback((record) => {
    setSelectedRow(record);
    setIsModalDeliveryAddressAdd(true);
  }, []);

  const handleDelete = useCallback(
    async (record) => {
      const id = record?.id;
      const body = {
        id: id,
      };
      setSelectedRowDelete(false);
      await dispatch(addressDelete(body));
      setIsVisibleDeleteModal(false);
    },
    [dispatch],
  );

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'receiverName',
      width: 20,
      align: 'left',
      render: (text, record, index) => {
        return (
          <div>
            <span>{index + 1}</span>
          </div>
        );
      },
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 35,
      className: 'custom-index-column',
      ellipsis: true,
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="deliveryAddressUpperCase" />
        </div>
      ),
      dataIndex: 'addressName',
      key: 'addressName',
      width: 50,
      align: 'left',
    },
    {
      title: <Text t="provinceUpperCase" />,
      dataIndex: 'cityName',
      key: 'cityName',
      width: 40,
      align: 'left',
    },
    {
      title: <Text t="districtUpperCase" />,
      dataIndex: 'countyName',
      key: 'countyName',
      width: 40,
      align: 'left',
    },
    {
      title: <Text t="neighborhoodUpperCase" />,
      dataIndex: 'neighborhoodName',
      key: 'neighborhoodName',
      width: 50,
      align: 'left',
      responsive: ['xl'],
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="recipient2" />
        </div>
      ),
      dataIndex: 'receiverName',
      key: 'receiverName',
      width: 60,
      align: 'left',
      responsive: ['xl'],
      render: (text, record) => {
        return (
          <div>
            <span>
              {text} {record?.receiverSurName}
            </span>
          </div>
        );
      },
    },
    {
      title: <Text t="openAddress3" />,
      dataIndex: 'detail',
      key: 'detail',
      width: 100,
      align: 'left',
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="totalTrCardsRegisteredToAddress" />
        </div>
      ),
      dataIndex: 'cardCount',
      key: 'cardCount',
      width: 55,
    },
    {
      title: (
        <div
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          <Text t="totalVehiclesRegisteredToAddress" />
        </div>
      ),
      dataIndex: 'carCount',
      key: 'carCount',
      width: 55,
    },
  ];

  if (
    !handleAuthStatus(userAuthorizationStatus, 'DeliveryAddressesDelete') ||
    !handleAuthStatus(userAuthorizationStatus, 'DeliveryAddressesEdit')
  ) {
    columns.push({
      title: '',
      width: 30,
      align: 'left',
      dataIndex: '',
      key: 'x',
      responsive: ['xl'],
      render: (text, record) => {
        return (
          <div>
            <Dropdown
              overlay={
                <UpdateMenu
                  record={record}
                  handleEdit={handleEdit}
                  setSelectedRowDelete={setSelectedRowDelete}
                  setSelectedRecord={setSelectedRecord}
                />
              }
              trigger={['click']}
              overlayStyle={{ zIndex: 50 }}
            >
              <Button
                type="text"
                icon={<CustomImage src={iconEllipsis} />}
                style={{
                  borderRadius: '0',
                  padding: '0',
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 'auto',
                  height: 'auto',
                }}
              />
            </Dropdown>
          </div>
        );
      },
    });
  }
  const listenClickCheckbox = (setList, tempList) => {
    setList(tempList);
  };

  return (
    <div className="user-list-card">
      <div
        style={{
          fontFamily: 'UbuntuMedium',
          fontSize: '18px',
          color: '#050505',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginLeft: '24px',
          marginRight: '16px',
          paddingTop: '15px',
          paddingBottom: '15px',
        }}
      >
        <div>
          <Text t="deliveryAddresses" />
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          {!handleAuthStatus(userAuthorizationStatus, 'DeliveryAddressesAdd') && (
            <Button
              onClick={handleAdd}
              type="text"
              icon={<CustomImage src={iconPlusBlack} />}
              style={{
                padding: '10px',
                borderRadius: '50%',
                borderColor: '#f1f5f9',
                backgroundColor: ' #f2f5f7',
                cursor: 'pointer',
                width: 'auto',
                height: 'auto',
              }}
            />
          )}
          <Dropdown
            overlay={
              <FilterMenu
                filteredText={filteredText}
                setFilteredText={setFilteredText}
                clickFilter={clickFilter}
                clearFilter={clearFilter}
                panels={panels}
                listenClickCheckbox={listenClickCheckbox}
              />
            }
            trigger={['click']}
          >
            <Button
              type="text"
              icon={<CustomImage src={iconFilterNew} />}
              style={{
                borderRadius: '50%',
                padding: '10px',
                borderColor: '#f1f5f9',
                backgroundColor: ' #f2f5f7',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'auto',
                height: 'auto',
              }}
            />
          </Dropdown>
        </div>
      </div>
      <CustomTable
        isScroll={false}
        expandedRowKeys={expandedRows}
        expandable={{
          showExpandColumn: false,
          expandIconColumnIndex: 11,
          onExpand: (expanded, record, key) =>
            expandedRows === key ? setExpandedRows(null) : setExpandedRows(key),
          expandIcon: getExpandIcon(),
          expandedRowRender: getExpandedRowRender(handleDelete, handleEdit),
        }}
        pagination={true}
        dataSource={addressPagedList}
        columns={columns}
        className="user-list-table"
        rowKey={(record) => record?.id}
      />
      <DeliveryAddressAddModal
        modalVisible={isModalDeliveryAddressAdd}
        handleModalVisible={setIsModalDeliveryAddressAdd}
        selectedRow={selectedRow}
      />
      <CustomModal
        className="visible-delete-modal"
        width={500}
        maskClosable={false}
        footer={false}
        title={' '}
        visible={isVisibleDeleteModal}
        onCancel={() => {
          setIsVisibleDeleteModal(false);
          setSelectedRowDelete(false);
        }}
        closeIcon={<CustomImage src={modalClose} />}
      >
        <div style={{ marginBottom: '24px', fontSize: '24px', fontFamily: 'UbuntuBold' }}>
          <Text t="deleteAddress" />
        </div>
        <div>
          {selectedRecord?.addressName} <Text t="registeredToDeliveryAddress" />
          {' ' + selectedRecord?.cardCount} <Text t="youHaveTicketRestaurantMealCardsAndVehicles" />
          {' ' + selectedRecord?.carCount} <Text t="youHaveVehicles" />
          <br />
          <br />
          <Text t="toCompletelyDeleteTheDeliveryAddressPleaseDefine" />
        </div>
        <Button
          onClick={() => handleDelete(selectedRecord)}
          style={{
            marginTop: '24px',
            backgroundColor: ' #162056',
            borderRadius: '6px',
            padding: '12px 40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
          }}
        >
          <Text t="okBtn" />
        </Button>
      </CustomModal>
    </div>
  );
};

export default DeliveryAdressesList;
